export default __webpack_public_path__ + "static/our-words-3-af8100405e8c33b0c8086a004d536697.jpg";